import moment from 'moment';
import validateSsn from './../helpers/validateSsn';
import validateAge from './../helpers/validateAge';

export default {
	dateIsInThePast(state) {
		return state.dates.current.weekStartDate >= state.dates.active.weekStartDate;
	},
	activityIsCampaign: (state) => (activity) => {
		var name = activity.activity_name.toLowerCase();
		if (name.indexOf('kampanj') !== -1) {
			return true;
		}
		return false;
	},
	formatProviderName: (state) => (name) => {
		/*
		var index = name.indexOf('Leg. Läkare');
		name = name.substring(0, index != -1 ? index : name.length);
		*/
		var newName = name.replace('Sandra Sellström Leg. Sjuksköterska', 'Sandra Sellström Injektionssjuksköterska');
		newName = newName.replace('Silvia Galaz Leg. Sjuksköterska', 'Silvia Galaz Injektionssjuksköterska');
		newName = newName.replace('Anna Hamberg Operationssjuksköterska', 'Anna Hamberg Specialistsjuksköterska');
		newName = newName.replace('Specialistsjuksköterska', '<br />Specialistsjuksköterska');
		newName = newName.replace('Leg. Läkare. Specialist i plastikkirurgi ', '<br />Plastikkirurg');
		newName = newName.replace('Leg. Läkare. Specialist i plastikkirurgi', '<br />Plastikkirurg');
		newName = newName.replace('Leg. Läkare Specialist i plastikkirurgi', '<br />Plastikkirurg');
		newName = newName.replace('Injektionsspecialist', '<br />Injektionsspecialist');
		newName = newName.replace('Aukt. Hudterapeut', '<br />Hudterapeut');
		newName = newName.replace('Injektionssjuksköterska', '<br />Injektionssjuksköterska');
		newName = newName.replace('Hudläkare', '<br />Hudläkare');
		newName = newName.replace('Leg. Sjuksköterska', '<br />Leg. Sjuksköterska');
		newName = newName.replace('Injektionsbehandlare', '<br />Injektionsbehandlare');
		newName = newName.replace('Tandläkare', '<br />Tandläkare');
		newName = newName.replace('LPG-terapeut', '<br />LPG-terapeut');
		return `<span class="practitioner-name">${newName.split('<br />')[0]}</span><span class="practitioner-title">${newName.split('<br />')[1]}</span>`;
	},
	formatProviderNameInList: (state) => (name) => {
		/* Adjust provider names */
		name = name.replace('Leg. Läkare. Specialist i plastikkirurgi ', 'Plastikkirurg');
		name = name.replace('Leg. Läkare. Specialist i plastikkirurgi', 'Plastikkirurg');
		name = name.replace('Leg. Läkare Specialist i plastikkirurgi', 'Plastikkirurg');
		name = name.replace('Aukt. Hudterapeut', 'Hudterapeut');

		name = name.replace('Sandra Sellström Leg. Sjuksköterska', 'Sandra Sellström Injektionssjuksköterska');
		name = name.replace('Silvia Galaz Leg. Sjuksköterska', 'Silvia Galaz Injektionssjuksköterska');
		name = name.replace('Anna Hamberg Operationssjuksköterska', 'Anna Hamberg Specialistsjuksköterska');
		return name;
	},
	formatLocationNameInList: (state) => (location) => {
		return location.short_name;
	},
	selectedSlotFormated(state) {
		var date = moment(state.selectedSlot.date);
		date = date.format('ddd') + ' ' + date.format('D MMMM');
		var capitalizedDate = date.charAt(0).toUpperCase() + date.slice(1);
		return capitalizedDate + ' kl. ' + state.selectedSlot.time + ', ' + state.selectedSlot.terapeut_sign;
	},
	formIsValid(state, getters) {
		/* Set a new variable that is the social security number of the patient without underscores. This is a workaround that is necessary because we use a mask on the user's input for the social security number */
		var ssnWithoutUnderscores = state.patient.ssn;
		ssnWithoutUnderscores = ssnWithoutUnderscores.replace('_', '');

		var formIsValid = true;

		/*
		After implementing BankID bookings, we no longer have to get the users first and last name since we get it from BankID.
		*/
		if (state.booking.authenticationFailed && !state.patient.firstName) {
			return false;
		}
		if (state.booking.authenticationFailed && !state.patient.lastName) {
			return false;
		}

		if (ssnWithoutUnderscores.length != 15) {
			formIsValid = false;
		} else {
			/* If the SSN is correct length, validate the age and the validity of the ssn itself */
			/* Validate the ssn */
			var validatedSsn = validateSsn(state.patient.ssn);
			if (validatedSsn) {
				state.ui.formErrors.ssn = false;
				/* If the SSN is valid, also check that the patient is at least 18 years old */
				var validatedAge = validateAge(state.patient.ssn);
				if (validatedAge) {
					state.ui.formErrors.ssnAge = false;
				} else {
					state.ui.formErrors.ssnAge = true;
					formIsValid = false;
				}
			} else {
				state.ui.formErrors.ssn = true;
				formIsValid = false;
			}
		}

		/* Validate the email */
		if (!getters.isEmailValid(state.patient.email)) {
			state.ui.formErrors.email = true;
			formIsValid = false;
		} else {
			state.ui.formErrors.email = false;
		}

		/* Validate the phone */
		if (!getters.isPhoneNumberValid(state.patient.phone)) {
			state.ui.formErrors.phone = true;
			formIsValid = false;
		} else {
			state.ui.formErrors.phone = false;
		}

		if (!state.patient.email) {
			formIsValid = false;
		}
		if (!state.patient.phone) {
			formIsValid = false;
		}
		if (!state.patient.gdprConsent) {
			formIsValid = false;
		}
		return formIsValid;
	},
	getRealWeekday() {
		if (moment().format('e') == '6') {
			return 'Sunday';
		}
		return false;
	},
	toTitleCase: (state) => (phrase) => {
		return phrase
			.toLowerCase()
			.split(' ')
			.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
			.join(' ');
	},
	/** Adjust the treatment length manually if needed.
	 * This is done as a hacky workaround to the fact that
	 * the ClinicBuddy API can't give us different treatment time lengths
	 * for different providers
	 **/
	getTreatmentLength(state) {
		var duration = state.activities.selected.activity_duration;

		/* If there is a custom treatment duration for the treatment, set the duration to that time */
		if (state.customTreatmentDurations) {
			if (state.customTreatmentDurations['activity_id_' + state.activities.selected.activity_id]) {
				if (
					state.customTreatmentDurations['activity_id_' + state.activities.selected.activity_id][
					'provider_id_' + state.selectedSlot.terapeut_id
					]
				) {
					duration =
						state.customTreatmentDurations['activity_id_' + state.activities.selected.activity_id][
						'provider_id_' + state.selectedSlot.terapeut_id
						];
				}
			}
		}

		return duration;

		/* The old hard coded custom durations are listed below. They are not used anymore, but are listed here for completeness. */

		/* If the provider is Magnus Kjelsberg Leg. Läkare. Specialist i plastikkirurg... */
		if (state.selectedSlot.terapeut_id == '94') {
			if (state.activities.selected.activity_id == '15') {
				duration = '45';
			}
			if (state.activities.selected.activity_id == '47') {
				duration = '45';
			}

			if (state.activities.selected.activity_id == '140') {
				duration = '45';
			}
		}

		/* If the provider is Hamid Natghian Leg. Läkare. Specialist i plastikkirurgi... */
		if (state.selectedSlot.terapeut_id == '74') {
			if (state.activities.selected.activity_id == '112') {
				duration = '15';
			}
		}

		/* If the provider is Marcus Ehrström Leg. Läkare. Specialist i plastikkirurgi... */
		if (state.selectedSlot.terapeut_id == '116') {
			if (state.activities.selected.activity_id == '3') {
				// Konsultation Bröstförstoring
				duration = '30';
			}
			if (state.activities.selected.activity_id == '4') {
				// Konsultation Bröstförstoring + lyft
				duration = '30';
			}
			if (state.activities.selected.activity_id == '194') {
				// Konsultation Mommy Makeover
				duration = '30';
			}
		}

		/* If the provider is Pehr Sommar... */
		if (state.selectedSlot.terapeut_id == '142') {
			if (state.activities.selected.activity_id == '24') {
				//Konsultation Armplastik OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '14') {
				//Konsultation Brazilian Butt Lift OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '3') {
				//Konsultation Bröstförstoring OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '4') {
				//Konsultation Bröstförstoring + lyft OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '5') {
				//Konsultation Bröstlyft OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '6') {
				//Konsultation Bröstreduktion OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '211') {
				//Konsultation Buccal Fatpad OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '10') {
				//Konsultation Bukplastik OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '15') {
				//Konsultation Konsultation Facelift / Ansiktslyft OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '9') {
				//Konsultation Fettsugning OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '180') {
				// Konsultation Fettransplantation Ansikte OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '13') {
				//Konsultation Gynekomasti OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '17') {
				//Konsultation Fettransplantation Kropp OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '140') {
				//Konsultation Halslyft OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '7') {
				//Konsultation Implantatbyte OK
				//duration = '30';
			}
			if (state.activities.selected.activity_id == '214') {
				//Konsultation Indragna Bröstvårtor OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '181') {
				//Konsultation Injektionsbehandling OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '12') {
				//Konsultation Intimkirurgi OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '219') {
				// Konsultation Käk-/Ansiktsimplantat OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '193') {
				//Konsultation Lipödem OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '23') {
				//Konsultation Lårplastik OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '212') {
				//Konsultation Läpplyft OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '194') {
				//Konsultation Mommy Makeover OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '209') {
				// Konsultation Rumpförstoring OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '47') {
				// Konsultation Pannlyft/Ögonbrynslyft OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '215') {
				// Konsultation Ryggplastik OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '213') {
				//Konsultation Vårtgårdsplastik OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '11') {
				//Konsultation Ögonlocksplastik OK
				//duration = '45';
			}
			if (state.activities.selected.activity_id == '16') {
				//Konsultation Öronplastik OK
				//duration = '45';
			}
		}

		/* If the provider is Petra Peterson */
		if (state.selectedSlot.terapeut_id == '153') {
			if (state.activities.selected.activity_id == '15') {
				//Konsultation Konsultation Facelift / Ansiktslyft OK
				duration = '60';
			}
			if (state.activities.selected.activity_id == '180') {
				// Konsultation Fettransplantation Ansikte OK
				duration = '45';
			}
			if (state.activities.selected.activity_id == '47') {
				// Konsultation Pannlyft/Ögonbrynslyft OK
				duration = '45';
			}
			if (state.activities.selected.activity_id == '140') {
				//Konsultation Halslyft OK
				duration = '45';
			}
			if (state.activities.selected.activity_id == '6') {
				//Konsultation Bröstreduktion OK
				duration = '45';
			}
			if (state.activities.selected.activity_id == '13') {
				//Konsultation Gynekomasti OK
				duration = '45';
			}
		}

		/* If the provider is Said Saidian... */
		if (state.selectedSlot.terapeut_id == '143') {
			if (state.activities.selected.activity_id == '24') {
				//Konsultation Armplastik OK
				duration = '45';
			}
			if (state.activities.selected.activity_id == '14') {
				//Konsultation Brazilian Butt Lift OK
				duration = '60';
			}
			if (state.activities.selected.activity_id == '3') {
				//Konsultation Bröstförstoring OK
				duration = '60';
			}
			if (state.activities.selected.activity_id == '4') {
				//Konsultation Bröstförstoring + lyft OK
				duration = '60';
			}
			if (state.activities.selected.activity_id == '5') {
				//Konsultation Bröstlyft OK
				duration = '45';
			}
			if (state.activities.selected.activity_id == '6') {
				//Konsultation Bröstreduktion OK
				duration = '45';
			}
			if (state.activities.selected.activity_id == '10') {
				//Konsultation Bukplastik OK
				duration = '45';
			}
			if (state.activities.selected.activity_id == '9') {
				//Konsultation Fettsugning OK
				duration = '45';
			}
			if (state.activities.selected.activity_id == '13') {
				//Konsultation Gynekomasti OK
				duration = '45';
			}
			if (state.activities.selected.activity_id == '17') {
				//Konsultation Fettransplantation Kropp OK
				duration = '60';
			}
			if (state.activities.selected.activity_id == '7') {
				//Konsultation Implantatbyte OK
				duration = '60';
			}
			if (state.activities.selected.activity_id == '214') {
				//Konsultation Indragna Bröstvårtor OK
				duration = '30';
			}
			if (state.activities.selected.activity_id == '181') {
				//Konsultation Injektionsbehandling OK
				duration = '30';
			}
			if (state.activities.selected.activity_id == '12') {
				//Konsultation Intimkirurgi OK
				duration = '45';
			}
			if (state.activities.selected.activity_id == '193') {
				//Konsultation Lipödem OK
				duration = '45';
			}
			if (state.activities.selected.activity_id == '23') {
				//Konsultation Lårplastik OK
				duration = '45';
			}
			if (state.activities.selected.activity_id == '212') {
				//Konsultation Läpplyft OK
				duration = '30';
			}
			if (state.activities.selected.activity_id == '194') {
				//Konsultation Mommy Makeover OK
				duration = '60';
			}
			if (state.activities.selected.activity_id == '213') {
				//Konsultation Vårtgårdsplastik OK
				duration = '30';
			}
			if (state.activities.selected.activity_id == '11') {
				//Konsultation Ögonlocksplastik OK
				duration = '30';
			}
			if (state.activities.selected.activity_id == '16') {
				//Konsultation Öronplastik OK
				duration = '30';
			}
		}

		/* If the provider is Sandra Sellström... */
		if (state.selectedSlot.terapeut_id == '24') {
			if (state.activities.selected.activity_id == '195') {
				//Läppförstoring
				duration = '60';
			}
			if (state.activities.selected.activity_id == '113') {
				//Fillers
				duration = '60';
			}
		}

		/* If the provider is Silvia Galaz... */
		if (state.selectedSlot.terapeut_id == '23') {
			if (state.activities.selected.activity_id == '195') {
				//Läppförstoring
				duration = '60';
			}
			if (state.activities.selected.activity_id == '113') {
				//Fillers
				duration = '60';
			}
		}

		/* If the provider is Denise Fa... */
		if (state.selectedSlot.terapeut_id == '9') {
			if (state.activities.selected.activity_id == '112') {
				//Botox 112
				duration = '15';
			}
			if (state.activities.selected.activity_id == '259') {
				//Glabella(Botox) 259
				duration = '15';
			}
			if (state.activities.selected.activity_id == '262') {
				//Gummysmile(Botox) 262
				duration = '15';
			}
			if (state.activities.selected.activity_id == '261') {
				//Kråksparkar(Botox) 261
				duration = '15';
			}
			if (state.activities.selected.activity_id == '260') {
				//Panna(Botox) 260
				duration = '15';
			}
			if (state.activities.selected.activity_id == '195') {
				//Läppförstoring
				duration = '15';
			}
		}

		/* If the provider is Danielle Fa... (there are two Danielle Fa in Clinicbuddy, one with ID 72 and one with ID 8) */
		if (state.selectedSlot.terapeut_id == '8') {
			if (state.activities.selected.activity_id == '112') {
				//Botox 112
				duration = '15';
			}
			if (state.activities.selected.activity_id == '259') {
				//Glabella(Botox) 259
				duration = '15';
			}
			if (state.activities.selected.activity_id == '262') {
				//Gummysmile(Botox) 262
				duration = '15';
			}
			if (state.activities.selected.activity_id == '261') {
				//Kråksparkar(Botox) 261
				duration = '15';
			}
			if (state.activities.selected.activity_id == '260') {
				//Panna(Botox) 260
				duration = '15';
			}
		}
		/* If the provider is Danielle Fa... (there are two Danielle Fa in Clinicbuddy, one with ID 72 and one with ID 8) */
		if (state.selectedSlot.terapeut_id == '72') {
			if (state.activities.selected.activity_id == '112') {
				//Botox 112
				duration = '15';
			}
			if (state.activities.selected.activity_id == '259') {
				//Glabella(Botox) 259
				duration = '15';
			}
			if (state.activities.selected.activity_id == '262') {
				//Gummysmile(Botox) 262
				duration = '15';
			}
			if (state.activities.selected.activity_id == '261') {
				//Kråksparkar(Botox) 261
				duration = '15';
			}
			if (state.activities.selected.activity_id == '260') {
				//Panna(Botox) 260
				duration = '15';
			}
		}

		/* If the provider is Mattias Elmér */
		if (state.selectedSlot.terapeut_id == '5') {
			/* Konsultation Brazilian Butt Lift */
			if (state.activities.selected.activity_id == '14') {
				//duration = '45';
			}
			/* Konsultation Bröstförstoring */
			if (state.activities.selected.activity_id == '3') {
				//duration = '45';
			}
			/* Konsultation Bröstförstoring + lyft */
			if (state.activities.selected.activity_id == '4') {
				//duration = '45';
			}
			/* Konsultation Bröstlyft */
			if (state.activities.selected.activity_id == '5') {
				//duration = '45';
			}
			/* Konsultation Bröstreduktion */
			if (state.activities.selected.activity_id == '6') {
				//duration = '45';
			}
			/* Konsultation Bukplastik */
			if (state.activities.selected.activity_id == '10') {
				//duration = '45';
			}
			/* Konsultation Fettsugning */
			if (state.activities.selected.activity_id == '9') {
				//duration = '45';
			}
			/* Konsultation Fettransplantation Kropp */
			if (state.activities.selected.activity_id == '17') {
				//duration = '45';
			}
			/* Konsultation Lipödem */
			if (state.activities.selected.activity_id == '193') {
				//duration = '45';
			}
			/* Konsultation Mommy Makeover */
			if (state.activities.selected.activity_id == '194') {
				//duration = '45';
			}
			/* Konsultation Rumpimplantat */
			if (state.activities.selected.activity_id == '209') {
				//duration = '45';
			}
			/* Konsultation Ryggplastik */
			if (state.activities.selected.activity_id == '215') {
				//duration = '45';
			}
		}
	},
	getSlotNiceDate: (state) => (date) => {
		var niceDate = moment(date);
		var day = '<span class="capitalize">' + niceDate.format('ddd') + '</span>';
		niceDate = day + ' ' + niceDate.format('D MMMM');
		return niceDate;
	},

	loading(state) {
		return state.ui.loading;
	},

	noAvailableTimesForWeek(state) {
		if (state.ui.loading.times) {
			return false;
		}
		let count = 0;
		for (let i in state.dates.active.weekdays) {
			let weekday = state.dates.active.weekdays[i];
			/* If a provider is selected, check if there are times for the provider */
			if (state.providers.selected) {
				for (let x in weekday.availableTimes) {
					let time = weekday.availableTimes[x];
					if (time.terapeut_sign == state.providers.selected) {
						count++;
					}
				}
				/* If a provider is not selected, check if there are any times in general */
			} else {
				count += weekday.availableTimes.length;
			}
		}
		if (count == 0) {
			return true;
		}

		return false;
	},
	totalAvailableTimes(state) {
		let availableTimes = [];
		for (let i in state.dates.active.weekdays) {
			let weekday = state.dates.active.weekdays[i];
			for (let x in weekday.activeTimes) {
				availableTimes.push(weekday.activeTimes[x]);
			}
		}
		return availableTimes;
	},

	showNextAvailableTimeButton(state) {
		return state.ui.showGetNextAvailableTimeButton;
	},

	getBankIDLocation(state) {
		var location = state.bankIDLocation;
		if (location != 'sameDevice' && location != 'otherDevice') {
			return 'sameDevice';
		}
		return state.bankIDLocation;
	},
	isSigningBankIDOnOtherDevice(state) {
		return state.ui.signingBankIDOnOtherDevice;
	},
	isSigningBankIDOnSameDevice(state) {
		return state.ui.signingBankIDOnSameDevice;
	},
	/* Detect if the user is using a mobile device. From https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser */
	isMobile() {
		let check = false;
		(function (a) {
			if (
				/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
					a
				) ||
				/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
					a.substr(0, 4)
				)
			)
				check = true;
		})(navigator.userAgent || navigator.vendor || window.opera);
		return check;
	},
	isIosOrAndroid() {
		var userAgent = navigator.userAgent || navigator.vendor || window.opera;
		if (/android/i.test(userAgent)) {
			return true;
		}
		if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
			return true;
		}
		return false;
	},
	/* 
	Detect if the user is using iOS 
	https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
	*/
	isIos() {
		return (
			['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
			// iPad on iOS 13 detection
			(navigator.userAgent.includes('Mac') && 'ontouchend' in document)
		);
	},
	isChromeOnIos() {
		return navigator.userAgent.match('CriOS');
	},
	isSafariOnIos() {
		var ua = window.navigator.userAgent;
		var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
		var webkit = !!ua.match(/WebKit/i);
		var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
		return iOSSafari;
	},
	isAndroid() {
		var userAgent = navigator.userAgent || navigator.vendor || window.opera;
		if (/android/i.test(userAgent)) {
			return true;
		}
		return false;
	},
	getAutostartUrl(state, getters) {
		var autostartUrl = false;
		/* Generate an autostart URL based on the client, i.e. different autostart URLs for different devices and browsers */
		if (state.booking.autostartToken) {
			/* Set up the URL correctly depending on if we're on IOS or Android, or not */
			/* See https://www.bankid.com/utvecklare/guider/teknisk-integrationsguide/programstart */
			var redirectUrl = 'null';
			if (getters.isIosOrAndroid) {
				/* If the user is using iOS and is using Safari, we can redirect them to the ordinary page URL since it'll open Safari for the user after signing with BankID. We add a hash to the URL to force the Safari browser to open the same tab in the browser. */
				if (getters.isIos) {
					/* If the user is using iOS and is using Chrome, we can redirect them to a specific Chrome URL to force iOS to open Chrome when the BankID signing is complete. */
					if (getters.isChromeOnIos) {
						/* For Chrome on iOS, just set the redirect URL to googlechrome://. This will open up the Chrome browser in the latest tab when the user has signed, i.e. the tab containing the booking page. */
						redirectUrl = 'googlechrome://';
					} else {
						/* If we're not on Chrome, we're probably on Safari, so contruct a redirect url accordingly. */
						redirectUrl = encodeURI(window.location.href + '#authComplete');
					}
				}
				if (getters.isAndroid) {
					/* If the user is using Android, we set the redirect parameter to "null" since this will ensure that the user will return to their previously used browser after signing with BankID, according to the BankID integration guide. */
					redirectUrl = 'null';
				}
			}
			autostartUrl = 'bankid:///?autostarttoken=' + state.booking.autostartToken + '&redirect=' + redirectUrl;
		}
		return autostartUrl;
	},

	isEmailValid: (state) => (email) => {
		var isValid = false;
		var re = /\S+@\S+\.\S+/;
		isValid = re.test(email);
		return isValid;
	},

	isPhoneNumberValid: (state) => (phone) => {
		var isValid = false;
		var minLength = 7;
		var maxLength = 17;
		if (phone.length >= minLength && phone.length <= maxLength) {
			isValid = true;
		}

		return isValid;
	},

	isActivityBookable: (state) => (activityId) => {
		var isBookable = true;
		if (state.unbookableTreatments) {
			if (state.unbookableTreatments.includes(parseInt(activityId))) {
				isBookable = false;
			}
		}
		return isBookable;
	},
};
